exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rule-edit-form .instruct-workflow-select.loading .ant-select-selection-item {\n  display: none;\n}\n.rule-edit-form .open-editor-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: -3px;\n  right: 8px;\n  z-index: 99;\n}\n.rule-edit-form .open-editor-button span {\n  font-size: 12px;\n  padding-top: 1px;\n}\n", ""]);

// exports
